import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { SharedButton } from './Button';

export default function ClientSelectFamily({ data, onClick, setPassPurchaseCondition, classID,preData }) {
    const [family_valid_class_ids, setFamily_valid_class_ids] = useState([]);

    useEffect(() => {
        if (data && data?.my_passes_details) {
            const pass_data = data?.my_passes_details || []
            let valid_class_ids = (pass_data || []).flatMap(element => {
                if (element.valid_class_id && element.valid_class_id.length > 0) {
                    let abcd = element.valid_class_id.filter(ee => ee === classID);
                    return abcd;
                }
                return [];
            });
            setFamily_valid_class_ids(valid_class_ids);
        }
    }, [data]);
    return (
        <>
            <Row>
                {data && data.my_passes_details && data.my_passes_details.length > 0 && data.my_passes_details.valid_class_id != '' && family_valid_class_ids.length > 0  ?
                    <Col>
                        <SharedButton onClick={() => onClick(data.my_passes_details, data, preData, 'family')} element={{ id: data.data }} title={"Sign Up"} variant={"secondary"} className={"btn btn-secondary purchasePassBtn mt-4 w-100"} />
                    </Col>
                    :
                    <Col>
                        <SharedButton
                            onClick={() => setPassPurchaseCondition(preData, data)}
                            title={"Purchase Pass"} variant={"secondary"} className={"btn btn-secondary purchasePassBtn mt-4 w-100"} />
                    </Col>
                }
            </Row>
        </>
    )
}
